import { addMonths, format } from 'date-fns';
import Decimal from 'decimal.js';
import { RevenueReportAggregateEnum } from 'anchor-scout-common/types';
import { useIoContext, useStore, useStoreActions } from '~/contexts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
import { HistoricRevenueModel } from '~/models/HistoricRevenueModel';
import { selectors } from '~/store/state-selectors';
import { FUTURE_INVOICE_LOOKAHEAD_MONTHS } from '~/store/store-actions';
export const useHistoricRevenueStats = function useHistoricRevenueStats() {
    let { refreshOnHookMount = false } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const { api } = useStoreActions();
    const { getNow } = useIoContext();
    const businessId = useStore(selectors.user.businessId);
    const { data, isLoading, isFetching, refresh, error } = useQueryState({
        queryKey: [
            QueryKeys.HistoricRevenueStats
        ],
        queryFn: async ()=>{
            const now = getNow();
            const to = format(addMonths(now, FUTURE_INVOICE_LOOKAHEAD_MONTHS), 'yyyy-MM-dd');
            const fetchIssuedTotal = async ()=>{
                if (!businessId) return new Decimal(0);
                const totalAmountInCents = await api.report.getIssuedTotalAmount(businessId);
                return new Decimal(totalAmountInCents).div(100);
            };
            const [historicPaidInvoices, historicPaidExternallyInvoices, futureRevenueTotals, issuedTotal] = await Promise.all([
                api.reports.revenueReportV3({
                    end: undefined,
                    start: undefined,
                    aggregate: RevenueReportAggregateEnum.Month,
                    services: [],
                    customers: [],
                    breakdowns: []
                }),
                api.report.getHistoricPaidExternallyInvoices(),
                api.report.getFutureInvoiceTotals({
                    to
                }),
                fetchIssuedTotal()
            ]);
            return HistoricRevenueModel.fromDTO(futureRevenueTotals, historicPaidInvoices, historicPaidExternallyInvoices, issuedTotal, now);
        },
        refreshOnHookMount
    });
    return {
        historicRevenueStats: data,
        isLoading,
        isFetching,
        refresh,
        error
    };
};
